import * as t from 'io-ts';

import {ApplicationAuthenticationStatusesEnum} from '../../applications/bridge/v2/types/bridgeTypesV2';
import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RApplicationPreferencesDirty = t.readonly(
  t.type({
    namespace: t.string,
    isInstalled: t.boolean,
    authentication: t.partial({
      status: t.literal(ApplicationAuthenticationStatusesEnum.AUTHORIZED),
    }),
    preferences: t.object,
    updatedAt: t.Integer,
  }),
);

/*
 * Type.
 */

export interface ApplicationPreferencesModel extends t.TypeOf<typeof RApplicationPreferencesDirty> {}
export const RApplicationPreferences = t.clean<ApplicationPreferencesModel>(
  RApplicationPreferencesDirty as any,
);

/*
 * IO methods.
 */

export function parseApplicationPreferences(src: any): ApplicationPreferencesModel {
  return {
    namespace: src.namespace,
    isInstalled: src.installed,
    authentication: src.authentication,
    preferences: src.settings,
    updatedAt: src.updated_at,
  };
}

/*
 * API type.
 */

export const ApiApplicationPreferences = makeApiType(
  'applicationPreferences',
  RApplicationPreferencesDirty,
  parseApplicationPreferences,
);
